import { useLocation } from 'react-router';

export const useAdminScreen = () => {
  const { pathname } = useLocation();
  return !!pathname.includes('/admin');
};
